import { useEffect } from 'react'

import * as Yup from 'yup'
import { useFormik, Form, FormikProvider } from 'formik'
import FormikControl from '../../../components/formik-control'

import Box from '@mui/material/Box'

import { usePostDispositionMutation } from '../../../services/dispositions/slice'

const toCamelCase = (label) => {
  return label
    .split(/[^A-Za-z0-9]+/)
    .map((word, index) =>
      index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join('')
}

const DispositionForm = ({ currentDisposition, onSubmitEvent, setSubmitEvent, setShowDrawer }) => {
  const [postDisposition] = usePostDispositionMutation()

  const initialValues = {
    id: currentDisposition?.id || '',
    code: currentDisposition?.code || '',
    isComplete: currentDisposition?.isComplete || false,
    isSuccess: currentDisposition?.isSuccess || false,
    label: currentDisposition?.label || '',
  }

  const validationSchema = Yup.object({
    code: Yup.string().required('Required'),
    label: Yup.string().required('Required'),
  })

  const onSubmit = async (values) => {
    const valuesToPost = {
      ...values,
    }

    await postDisposition(valuesToPost)
    setSubmitEvent()
    setShowDrawer(false)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(() => {
    if (onSubmitEvent) {
      formik.handleSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSubmitEvent])

  useEffect(() => {
    const newCode = toCamelCase(formik.values.label)
    if (newCode !== formik.values.code) {
      formik.setFieldValue('code', newCode)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.label])

  return (
    <>
      <FormikProvider value={formik}>
        <Form>
          <Box>
            <FormikControl control="input" label="Code" name="code" fullWidth margin="normal" disabled />
          </Box>
          <Box>
            <FormikControl control="input" label="Label" name="label" fullWidth margin="normal" />
          </Box>
          <Box>
            <FormikControl control="checkbox" label="Is Complete" name="isComplete" />
          </Box>
          <Box>
            <FormikControl control="checkbox" label="Is Successful" name="isSuccess" />
          </Box>
        </Form>
      </FormikProvider>
    </>
  )
}

export default DispositionForm
